import {makeStyles} from '@mui/styles'

export default makeStyles((theme) => ({
      mainContainer:{
        justifyContent : "space-between",
        [theme.breakpoints.down('sm')]: {
          flexDirection : 'column-reverse!important',
        }
      }
  }));